module.exports = __webpack_public_path__ + "static/media/Search Duo.cd2f405d.svg";